import { configureStore } from "@reduxjs/toolkit";
import { baseApi } from "./api/baseApi";
import { chatBaseApi } from "./api/chatApi";
import storage from "redux-persist/lib/storage";
import authReducer from "./feature/auth/authSlice";
import globalReducer from "./feature/global/globalSlice";
import signUpReducer from "./feature/creatorApplication/creatorApplicationSlice";
import { sidebarReducer } from "./feature/sidebar/sidebarSlice";
import signUpV2Reducer from "./feature/creatorApplicationV2/creatorApplicationSliceV2";
import tourReducer from "./feature/tour/tourSlice";

import userReducer from "./feature/user/userSlice";

import {
  persistReducer,
  persistStore,
  FLUSH,
  REHYDRATE,
  PAUSE,
  PERSIST,
  PURGE,
  REGISTER,
} from "redux-persist";

const persistConfig = {
  key: "auth",
  storage,
};

const persistedAuthReducer = persistReducer(persistConfig, authReducer);

export const store = configureStore({
  reducer: {
    auth: persistedAuthReducer,
    signUp: signUpReducer,
    signUpV2: signUpV2Reducer,

    global: globalReducer,
    sidebar: sidebarReducer,

    user: userReducer,

    tour: tourReducer,

    [baseApi.reducerPath]: baseApi.reducer,
    [chatBaseApi.reducerPath]: chatBaseApi.reducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
      // serializableCheck: {
      //   ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER],
      //   ignoredPaths: [],
      // },
    }).concat(baseApi.middleware, chatBaseApi.middleware),
});

// Infer the `RootState` and `AppDispatch` types from the store itself
export type RootState = ReturnType<typeof store.getState>;
// Inferred type: {posts: PostsState, comments: CommentsState, users: UsersState}
export type AppDispatch = typeof store.dispatch;

export const persistor = persistStore(store);
